<template>
  <b-card bg-variant="secondary">
    <secure-upload
      :endpoint="authdocpath"
      @file-uploaded="bijlagen.push($event)"
    />

    <b-container class="my-2 p-0"> 
      {{ bijlagen.length }} bijlagen
    </b-container>

    <b-button 
      v-for="(doc, index) in bijlagen" 
      :key="doc.document.public_id" 
      :href="doc.document.secure_url"
      variant="dark"
      target="_blank"
      pill
    >
      <font-awesome-icon icon="paperclip" />
      {{ doc.document.original_filename }}.{{
        doc.document.format
      }} ({{ formatBytes(doc.document.bytes) }})
      <b-button 
        size="sm"
        pill
        variant="secondary"
        @click="bijlagen.splice(index, 1)"
      >
        <i class="fa fa-times" />
      </b-button>
    </b-button>
  </b-card>
</template>
<script>
import SecureUpload from '../views/administratie/documenten/SecureUpload.vue'
export default {
    name: 'SecureBijlagen',
    components: {SecureUpload},
    mixins: [],
    props: {
        authdocpath: {
            type: String,
            default: `/documenten/donkenliftadvies/${new Date().getUTCFullYear()}/authenticated`
        },
        bijlagen: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return  {
        }
    },
    computed: {},
    watch: {},
    mounted () {
        
    },
    methods: {
      formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes";

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
      },
    },
        
}
</script>
